import { render, staticRenderFns } from "./CategoriesListDraggable.vue?vue&type=template&id=5e279f11&"
import script from "./CategoriesListDraggable.vue?vue&type=script&lang=js&"
export * from "./CategoriesListDraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports